import { Maybe, Survey } from 'generated/graphql';
import { IntegrationSurveyType } from 'v2/core/entities/integrations';

export const mapEdgeDataToSurveys = (
  surveys: Maybe<Survey>[],
): IntegrationSurveyType[] => {
  return surveys?.map((survey) => ({
    name: survey?.name ?? '',
    surveyID: survey?.surveyID ?? '',
  }));
};
